module.exports = __webpack_public_path__ + "img/message_9.047f1472.png";